import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SocialMediaService } from 'src/app/services/social-media/social-media.service';
import { UntypedFormGroup } from '@angular/forms';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-social-media-share',
  templateUrl: './social-media-share.component.html',
  styleUrls: ['./social-media-share.component.scss'],
  providers: [SocialMediaService]
})
export class SocialMediaShareComponent implements OnInit {

  portals = [];
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  share_link;
  smp_template: any = [];
  smp_template_ref: any = [];
  smp_template_length;
  smp_template_index;
  isLinear = false;
  constructor(
    public dialogRef: MatDialogRef<SocialMediaShareComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _snackBar: MatSnackBar,
    private profile_settings: ProfileSettingsService,
    private notification: NotificationService
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

    if (this.data) {
      this.share_link = this.data.share_link;
    }
    this.profile_settings.loadDefaultSettings().subscribe(res => {
      this.portals = res['data'].socialMediaList;
    })
  }

  share(media) {
    if (media && media.link) {
      let out_str = media.link;
      out_str = out_str.replace(/\[JobLink\]/g, this.share_link);
      window.open(out_str, '_blank');
    }
  }

  copyLink(param) {
    let inp = document.getElementById('share_link_input') as HTMLInputElement;
    inp.focus();
    inp.select();
    document.execCommand('copy');
    this.notification.success('Link copied');
  }

  // copyTemplate(param) {
  //   // let inp = document.getElementById('temp_body_input') as HTMLInputElement;
  //   let inp = param;
  //   inp.focus();
  //   inp.select();
  //   document.execCommand('copy');
  // }

  openMail(data) {
    let mail = "mailto:?subject=" + data.emailShareContentSubject + "&body=" + data.emailShareContentMailBody;
    window.open(mail, '_blank')
  }
  copyTemplate(val: string, stepper: MatStepper) {
    let temp = document.createElement('textarea');
    temp.style.position = 'fixed';
    temp.style.left = '0';
    temp.style.top = '0';
    temp.style.opacity = '0';
    temp.value = val;
    document.body.appendChild(temp);
    temp.focus();
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
    this._snackBar.open('Copied a Template');
    stepper.next();
  }

  nextMedia() {
    if (this.smp_template_index < this.smp_template_length) {
      this.smp_template_index++;
      this.smp_template_ref = this.smp_template[this.smp_template_index - 1];
    }
  }
  prevMedia() {
    if (this.smp_template_index > 1) {
      this.smp_template_index--;
      this.smp_template_ref = this.smp_template[this.smp_template_index - 1];
    }
  }
  skip(stepper: MatStepper) {

    //if a language is selected, create a new language tab
    // this._snackBar.open('Copied a Template');
    stepper.next();

  }
}
